// extracted by mini-css-extract-plugin
export var infoItem = "_r8-2";
export var title = "_r8-0";
export var value = "_r8-1";